module.exports = __webpack_public_path__ + "static/media/NMMA Advocacy Year-in-Review (1) (1).c677edca.docx";